import React, {useEffect} from "react";
import {globallyClearErrors} from "@/features/user";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {Modal} from "bootstrap";
import {closeBootstrapModal} from "@/helpers/closeBootstrapModal.js";
import {selectUserErrorMsg} from "@/features/user/userSelectors";

export default function PageSanitiser({children}) {
  const {pathname} = useLocation();
  const dispatch = useDispatch();
  const errorMsg = useSelector(selectUserErrorMsg);

  useEffect(() => {
    if (errorMsg) {
      dispatch(globallyClearErrors());
    }

    const modals = document.querySelectorAll(".modal");
    modals?.forEach(modal => {
      const modalId = modal.getAttribute("id");
      const currentModal = Modal.getInstance(modal);
      document.querySelectorAll(".modal-backdrop")?.forEach(el => el.remove());
      if (this != modal && currentModal) {
        document.querySelectorAll(".modal-backdrop")?.forEach(el => el.remove());
        closeBootstrapModal(modalId);
      }
    });

    document.querySelector("#root").scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname, dispatch]);

  return children;
}
